import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginHeaderComponent } from '@kp/screen-login/login-header/login-header.component';
import { ScreenLoginRoutingModule } from '@kp/screen-login/screen-login-routing.module';
import { SharedModule } from '@kp/shared/shared.module';

@NgModule({
  declarations: [ScreenLoginRoutingModule.components],
  exports: [LoginHeaderComponent],
  imports: [CommonModule, ScreenLoginRoutingModule, ReactiveFormsModule, SharedModule, FormsModule],
})
export class ScreenLoginModule {}
